import { useSubdomain } from '../hooks/useSubdomain';
import Landing from '../pages/Landing';
import CoursedeeLanding from '../pages/CoursedeeLanding';

export default function SubdomainAwareLanding() {
  const { isSubdomain } = useSubdomain();
  
  // Check if current domain is คอร์สดี.com
  const hostname = window.location.hostname;
  const isCoursedeeDomain = hostname === 'aiforyou.web.app' ||
                          hostname === 'www.aiforyou.web.app';
  
  console.log('[SubdomainAwareLanding] hostname:', hostname);
  console.log('[SubdomainAwareLanding] isCoursedeeDomain:', isCoursedeeDomain);
  
  // Don't render Landing page on subdomain - SubdomainHandler will show instructor profile
  if (isSubdomain) {
    return null;
  }
  
  // Show AI landing page for คอร์สดี.com
  if (isCoursedeeDomain) {
    console.log('[SubdomainAwareLanding] Showing CoursedeeLanding (AI page)');
    return <CoursedeeLanding />;
  }
  
  // Show course creation landing page for edumi.co
  console.log('[SubdomainAwareLanding] Showing Landing (course creation page)');
  return <Landing />;
}
